const ADD_TO_CART = 'ADD_TO_CART'
const ITEM_NOTE = 'ITEM_NOTE'
const GET_CART = 'GET_CART'
const UPDATE_CART = 'UPDATE_CART'
const EMPTY_CART = 'EMPTY_CART'
const GET_WISHLIST = 'GET_WISHLIST'
const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST'
const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST'
const CHANGE_QTY = 'CHANGE_QTY'
const DISCOUNT_CODE = 'DISCOUNT_CODE'
export {
    ADD_TO_CART,
    ITEM_NOTE,
    REMOVE_FROM_CART,
    CHANGE_QTY,
    ADD_TO_WISHLIST,
    REMOVE_FROM_WISHLIST,
    GET_CART,
    UPDATE_CART,
    EMPTY_CART,
    GET_WISHLIST,
    DISCOUNT_CODE,
}
